'use client'

import { useEffect } from 'react'

import { logAmplitude } from '@/hooks/useAmplitude'

interface PageViewTrackerProps {
  logReferrer: boolean | null
  initialReferrer?: string | null
  page: string
  eventProperties?: Record<string, any> | null
}

export function PageViewTracker({
  logReferrer,
  initialReferrer,
  page,
  eventProperties,
}: PageViewTrackerProps) {
  useEffect(() => {
    const currentReferrer = document.referrer || initialReferrer

    const combinedProperties = {
      ...(eventProperties || {}),
      ...(logReferrer ? { 'page.referrer': currentReferrer } : {}),
      'page.url': window.location.href,
    }

    logAmplitude(`${page} page viewed`, combinedProperties)
  }, []) // Empty dependency array means this runs on every mount

  return null // This component just tracks, doesn't render anything
}
